<template>
  <v-row no-gutters>
    <template>
      <v-col cols="12" class="pr-0">
        <div class="upCardAnalyticsGraphic px-4 py-2">
          <v-col cols="12">
            <v-row no-gutters align="center" justify="space-between">
              <span class="body-bold-medium">
                {{ $t('message.pages.analyticsV3.plays') }}
              </span>
              <span class="body-regular-smaller neutral-40-light--text">
                {{
                  $t('message.pages.analyticsV3.pages.devices.updatedAgo', {
                    time: lastUpdatedMinutes,
                  })
                }}
              </span>
            </v-row>

            <span class="body-regular-smaller neutral-40-light--text">
              {{ $t('message.pages.analyticsV3.playsSubtitle') }}
              <a
                class="body-bold-smaller neutral-30-base--text span-link"
                @click="handleGoToAnalyticsArticle"
              >
                {{ $t('message.commom.learnMore') }}
                <v-icon size="12" color="neutral-30-base"
                  >mdi-open-in-new</v-icon
                >
              </a>
            </span>
          </v-col>

          <v-col cols="12">
            <v-row no-gutters align="center" justify="space-between">
              <div class="d-flex flex-wrap align-center">
                <div
                  class="metric-btn d-flex align-center"
                  v-for="metric in metrics"
                  :key="metric.key"
                >
                  <div
                    class="d-flex align-center pa-1"
                    :class="{
                      'metric-btn--opacity':
                        !!filterByMetric && filterByMetric !== metric.key,
                    }"
                    style="gap: 8px"
                    @click="() => handleFilterByMetric(metric.key)"
                  >
                    <v-badge
                      class="my-badge-scope"
                      inline
                      :color="metric.color"
                    />
                    <div class="d-flex align-center" style="user-select: none">
                      <span
                        class="body-regular-smaller neutral-20-dark--text mr-1"
                      >
                        {{ metric.label }}:
                      </span>
                      <v-skeleton-loader
                        v-if="loadings.fetch"
                        width="36"
                        height="14"
                        type="image"
                      />
                      <span
                        v-else
                        class="body-regular-smaller neutral-20-dark--text"
                      >
                        {{ Number(metric.value).toLocaleString() }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 124px">
                <base-select
                  v-model="showPlotBy"
                  :items="showPlotByPlaceholders"
                  :menu-props="{ top: false, offsetY: true }"
                  item-text="name"
                  item-value="value"
                  dense
                  hide-details
                  attach
                />
              </div>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-row class="ma-2 mb-4" v-if="loadings.fetch" no-gutters>
              <v-skeleton-loader type="image" width="100%"></v-skeleton-loader>
            </v-row>
            <v-card
              class="d-flex flex-row align-center justify-center"
              flat
              height="250px"
              width="100%"
              v-else-if="errors.unknownError"
            >
              <ad-block-error-message
                v-if="isAdBlockEnabled"
                :isLoading="loadings.fetch"
                @handleFetchData="handleUpdateAnalytics"
              />
              <v-row
                class="flex-column"
                justify="center"
                align="center"
                no-gutters
                v-else
              >
                <v-card flat height="30" class="mb-4">
                  <span class="footerText align-text d-block">
                    {{ errors.shownErrMsg }}
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon size="18" v-bind="attrs" v-on="on">
                          mdi-help-circle
                        </v-icon>
                      </template>
                      <v-container
                        class="text-body-2 pa-0"
                        style="max-width: 230px"
                      >
                        {{ errors.tooltipErrMsg }}
                      </v-container>
                    </v-tooltip>
                  </span>
                </v-card>
                <v-btn
                  color="primary"
                  class="ml-3"
                  @click="handleUpdateAnalytics"
                  >{{ $t('message.pages.analytics.tryAgain') }}</v-btn
                >
              </v-row>
            </v-card>
            <apexchart
              v-else
              :class="{ darkThemeSvgFix: $vuetify.theme.dark }"
              ref="playsChart"
              type="line"
              height="300"
              width="100%"
              :options="getChartOptions"
              :series="filteredChartSeries"
              :key="showPlotBy + '-' + chartCategories.join(',')"
            ></apexchart>
          </v-col>
          <apexchart
            v-if="chartCategories.length > 0 && isCapturingPdf"
            class="pdf-export-chart"
            ref="fakeChart"
            type="line"
            height="300"
            width="894"
            :options="pdfOptions"
            :series="filteredChartSeries"
            :key="'fake'"
          />
        </div>

        <div v-if="isCapturingPng" class="capture-clone">
          <div ref="chartContainerForCapture" style="width: 100%; height: 100%; background: white; padding: 16px;">
              <v-col cols="12">
                  <v-row no-gutters align="center" justify="space-between">
                      <span class="body-bold-medium" style="color: #282931;">
                          {{ $t('message.pages.analyticsV3.plays') }}
                      </span>
                  </v-row>
                  <span class="body-regular-smaller" style="color: #636578;">
                      {{ $t('message.pages.analyticsV3.playsSubtitle') }}
                  </span>
              </v-col>
              <v-col cols="12">
                  <v-row no-gutters align="center" justify="space-between">
                      <div class="d-flex flex-wrap align-center">
                          <div class="metric-btn d-flex align-center" v-for="metric in metrics" :key="metric.key">
                              <div class="d-flex align-center pa-1" style="gap: 8px">
                                  <v-badge class="my-badge-scope" inline :color="metric.color" />
                                  <div class="d-flex align-center" style="user-select: none">
                                      <span class="body-regular-smaller  mr-1" style="color: #282931;">{{ metric.label }}:</span>
                                      <span class="body-regular-smaller" style="color: #282931;">{{ Number(metric.value).toLocaleString() }}</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </v-row>
              </v-col>
              <v-col cols="12" class="pa-0">
                  <apexchart
                    v-if="!loadings.fetch"
                    :class="{ darkThemeSvgFix: $vuetify.theme.dark }"
                    type="line"
                    height="300"
                    width="100%"
                    :options="pdfOptions"
                    :series="filteredChartSeries"
                    :key="showPlotBy + '-' + chartCategories.join(',') + '-clone'"
                  ></apexchart>
              </v-col>
          </div>
        </div>

        <div class="upCardAnalyticsTable pa-6">
          <v-row no-gutters>
            <v-col cols="12">
              <v-input
                v-if="!loadings.fetch"
                v-model="searchVideoText"
                class="search-bar"
                dense
                outlined
                size="small"
                :placeholder="$t('message.pages.analytics.account.search')"
                hide-details
                @input="doItemsSearch"
              >
                <template v-slot:prepend-inner>
                  <v-icon class="neutral-60--text" size="16">
                    mdi-magnify
                  </v-icon>
                </template>
              </v-input>
            </v-col>
          </v-row>

          <v-col cols="12" class="pa-0">
            <div class="scrollable-content" @scroll="handleScroll">
              <div
                v-if="nothingFound"
                class="emptyStateTrafficModal d-flex justify-center align-center flex-column"
              >
                <span
                  class="emptyState--title text-neutral-20- body-regular-large"
                >
                  {{ $t('message.pages.analytics.account.notFound') }}
                </span>
              </div>

              <BaseTable
                :items="
                  searchVideoText.length > 0
                    ? filteredRankingItems
                    : filteredVideosData
                "
                :columns="visibleTableColumns"
                :loading="loadings.fetch"
                :items-per-page="10"
                :show-pagination="true"
                :showActionColumn="true"
                :isSearching="searchVideoText.length > 0"
                @clear-search="clearSearch"
                noPointer
              >
                <template #gb_costHeader>
                  <span class="body-regular-small">
                    {{ $t('message.pages.analytics.account.averageCost')
                    }}<br />
                    <span class="body-regular-xsmall"
                      >Custo médio por play</span
                    >
                  </span>
                </template>
                <template #titleCell="{ row }">
                  <span class="text-truncate" :title="row.title">
                    {{ truncateTitle(row.title) }}
                  </span>
                </template>
                <template #playCell="{ row }">
                  <span class="body-regular-small">
                    {{
                      Number(row.play).toLocaleString(currencyLocale, {
                        currency: currency,
                      })
                    }}
                  </span>
                </template>
                <template #unique_playCell="{ row }">
                  <span class="body-regular-small">
                    {{
                      Number(row.unique_play).toLocaleString(currencyLocale, {
                        currency: currency,
                      })
                    }}
                  </span>
                </template>
                <template #viewCell="{ row }">
                  <span class="body-regular-small">
                    {{
                      Number(row.view).toLocaleString(currencyLocale, {
                        currency: currency,
                      })
                    }}
                  </span>
                </template>
                <template #unique_viewCell="{ row }">
                  <span class="body-regular-small">
                    {{
                      Number(row.unique_view).toLocaleString(currencyLocale, {
                        currency: currency,
                      })
                    }}
                  </span>
                </template>
                <template #playRateCell="{ row }">
                  <span class="body-regular-small"> {{ row.playRate }}% </span>
                </template>
                <template #gb_costCell="{ row }">
                  <span class="body-regular-small">
                    {{
                      formatAverageCost(
                        row.gb_cost && row.gb_cost.video_cost_in_day,
                        row.play
                      )
                    }}
                  </span>
                </template>
                <template #gb_cost_per_playCell="{ row }">
                  <span class="body-regular-small">
                    {{
                      row.gb_cost_per_play === 0 ||
                      row.gb_cost_per_play === '0' ||
                      row.gb_cost_per_play === 0.0
                        ? 'N/A'
                        : formatAverageCost(
                            row.gb_cost && row.gb_cost.video_cost_in_day,
                            row.play
                          )
                    }}
                  </span>
                </template>
                <template #actionHeader>
                  <!-- Remove action header slot -->
                </template>
              </BaseTable>
            </div>
          </v-col>
        </div>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { format, subDays } from 'date-fns'
import { mapState, mapMutations } from 'vuex'
import AdBlockErrorMessage from '@/components/AdBlockErrorMessage.vue'

import newAnalyticsApi from '@/services/newAnalyticsApi'
import Fuse from 'fuse.js'
import VueApexCharts from 'vue-apexcharts'
import BaseTable from '@/components/BaseComponents/BaseTable.vue'
import BaseSelect from '@/components/BaseComponents/BaseSelect.vue'
import { enUS, ptBR, es as esES } from 'date-fns/locale'
import { exportToCsv } from '@/utils/csvExporter.js'
import { exportToPng } from '@/utils/pngExporter.js'
import { generatePdfBlob } from '@/utils/pdfExporter.js'
import { dataFormatter } from '@/utils/dataFormatter'
import currencyMixin from '../../mixins/currencyMixin'

export default {
  name: 'Views',
  components: {
    AdBlockErrorMessage,
    apexchart: VueApexCharts,
    BaseTable,
    BaseSelect,
  },
  mixins: [currencyMixin],
  data() {
    return {
      isCapturingPng: false, 
      isCapturingPdf: false,
      currentlyVisibleColumns: [],
      analyticsLinks: {
        pt: 'https://help.pandavideo.com/pt-br/article/como-funcionam-as-metricas-do-analytics-na-panda-video-qk2m59/',
        en: 'https://help.pandavideo.com/en-us/article/how-do-analytics-metrics-work-in-panda-video-kinu6m/',
        es: 'https://help.pandavideo.com/es/article/como-funcionan-las-metricas-de-analytics-en-panda-video-cpkcfv/',
      },
      searchVideoText: '',
      loadings: {
        fetch: true,
      },
      viewChartSeries: [],
      totalData: {
        views: 0,
        uniqueViews: 0,
        plays: 0,
        uniquePlays: 0,
        playRate: 0,
        uniquePlayRate: 0,
      },
      tableData: [],
      videosData: [],
      errors: {
        fetch: false,
        unknownError: false,
        shownErrMsg: '',
        tooltipErrMsg: '',
      },
      filteredRankingItems: [],
      chartCategories: [],
      nameOrder: 'desc',
      viewsOrder: 'desc',
      playsOrder: 'desc',
      uniqueViewsOrder: 'desc',
      uniquePlaysOrder: 'desc',
      playrateOrder: 'desc',
      noInfoFound: false,
      page: 1,
      pageCount: 0,
      nothingFound: false,
      isScrolled: false,
      filterByMetric: null,
      rawViewsData: null,
      lastUpdatedAt: 0,
      lastUpdatedTimeout: null,
      showPlotBy: 'daily',
      rawVideoDataById: {},
    }
  },
  computed: {
    ...mapState('user', {
      planInfo: 'userPlanInfo',
    }),
    metrics() {
      return [
        {
          key: 'play',
          label: this.$t('message.pages.analyticsV3.reference.play'),
          color: '#3F55EE',
          value: this.totalData.plays,
        },
        {
          key: 'unique_play',
          label: this.$t('message.pages.analyticsV3.reference.unique_play'),
          color: '#20C1A4',
          value: this.totalData.uniquePlays,
        },
        {
          key: 'view',
          label: this.$t('message.pages.analyticsV3.reference.view'),
          color: '#FF882B',
          value: this.totalData.views,
        },
        {
          key: 'unique_view',
          label: this.$t('message.pages.analyticsV3.reference.unique_view'),
          color: '#9D1DA0',
          value: this.totalData.uniqueViews,
        },
      ]
    },
    ...mapState({
      isAdBlock: (state) => state.dashboard.isAdBlockEnabled,
      dateRange: (state) => state.analytics.filters.dateRange,
      selectedVideos: (state) =>
        state.analytics.filters.filterVideos.selectedVideos,
    }),
    locale() {
      return this.$i18next.resolvedLanguage
    },
    tableDataForCsv() {
      if (this.searchVideoText.length > 0) {
        return this.filteredRankingItems
      }
      return this.filteredVideosData
    },
    isRangeMoreThan30Days() {
      if (!this.dateRange || !this.dateRange.start || !this.dateRange.end)
        return false
      const start = new Date(this.dateRange.start)
      const end = new Date(this.dateRange.end)
      const diff = (end - start) / (1000 * 60 * 60 * 24)
      return diff >= 30
    },
    rotateAlways() {
      return this.isRangeMoreThan30Days && this.showPlotBy === 'daily'
    },
    showPlotByPlaceholders() {
      return [
        {
          value: 'daily',
          name: this.$t('message.pages.analyticsV3.daily'),
        },
        {
          value: 'weekly',
          name: this.$t('message.pages.analyticsV3.weekly'),
        },
        {
          value: 'monthly',
          name: this.$t('message.pages.analyticsV3.monthly'),
        },
      ]
    },
    baseTableColumns() {
      return [
        {
          text: this.$t('message.pages.videosDataTable.header.name'),
          value: 'title',
          align: 'start',
          width: '40%',
        },
        {
          text: this.$t('message.pages.analytics.account.plays'),
          value: 'play',
          align: 'end',
          width: '10%',
          tooltip: this.$t('message.pages.analytics.account.playsTooltip'),
        },
        {
          text: this.$t('message.pages.analytics.account.uniquePlays'),
          value: 'unique_play',
          align: 'end',
          width: '10%',
          tooltip: this.$t(
            'message.pages.analytics.account.uniquePlaysTooltip'
          ),
        },
        {
          text: this.$t('message.pages.analytics.account.views'),
          value: 'view',
          align: 'end',
          width: '10%',
          tooltip: this.$t('message.pages.analytics.account.viewsTooltip'),
        },
        {
          text: this.$t('message.pages.analytics.account.uniqueViews'),
          value: 'unique_view',
          align: 'end',
          width: '10%',
          tooltip: this.$t(
            'message.pages.analytics.account.uniqueViewsTooltip'
          ),
        },
        {
          text: 'Play rate',
          value: 'playRate',
          align: 'end',
          width: '10%',
          tooltip: this.$t('message.pages.analytics.account.playrateTooltip'),
          formatter: (value) => `${value}%`,
        },
        {
          text: this.$t('message.pages.analytics.account.averageCost'),
          value: 'gb_cost_per_play',
          align: 'end',
          width: '10%',
          tooltip: this.$t(
            'message.pages.analytics.account.averageCostTooltip'
          ),
          formatter: (value, row) => {
            return this.formatAverageCost(
              row.gb_cost && row.gb_cost.video_cost_in_day,
              row.play
            )
          },
        },
      ]
    },
    tableHeaders() {
      return [
        {
          text: this.$t('message.pages.videosDataTable.header.name'),
          align: 'start',
          value: 'title',
          width: '40%',
          icon: false,
        },
        {
          align: 'end',
          value: 'plays',
          width: '12.5%',
          icon: true,
        },
        {
          align: 'end',
          value: 'uniquePlays',
          width: '12.5%',
          icon: true,
        },
        {
          align: 'end',
          value: 'views',
          width: '12.5%',
          icon: true,
        },
        {
          align: 'end',
          value: 'uniqueViews',
          width: '12.5%',
          icon: true,
        },
        {
          text: 'Play rate',
          align: 'end',
          value: 'playrate',
          width: '12.5%',
          icon: true,
        },
      ]
    },
    headers() {
      return [
        {
          prop: '_action',
          name: 'Nome',
          actionName: 'titleCommon',
        },
        {
          prop: '_action',
          name: 'Visualizações',
          actionName: 'view',
          width: this.tableHeight <= 288 ? 110 : 100,
        },
        {
          prop: '_action',
          name: 'Plays',
          actionName: 'play',
          width: this.tableHeight <= 288 ? 90 : 90,
        },
        {
          prop: '_action',
          name: 'Visualizações Únicas',
          actionName: 'uniqueView',
          width: this.tableHeight <= 288 ? 140 : 140,
        },
        {
          prop: '_action',
          name: 'Plays Únicos',
          actionName: 'uniquePlay',
          width: this.tableHeight <= 288 ? 140 : 150,
        },
        {
          prop: '_action',
          name: 'Playrate',
          actionName: 'playrate',
          width: this.tableHeight <= 288 ? 160 : 140,
        },
      ]
    },
    tableHeight() {
      if (this.videosData.length < 5) {
        return 288
      } else if (this.videosData.length <= 100) {
        return (this.videosData.length + 1) * 48 + 5
      } else {
        return 4805
      }
    },
    isAdBlockEnabled() {
      if (this.isAdBlock) {
        return this.isAdBlock
      }
      return false
    },
    visibleTableColumns() {
      return this.baseTableColumns.map((col) => ({
        ...col,
        width: 100 / this.baseTableColumns.length + '%',
      }))
    },
    filteredChartSeries() {
      if (!this.viewChartSeries.length) return []
      const colorMap = {
        play: '#3F55EE',
        unique_play: '#20C1A4',
        view: '#FF882B',
        unique_view: '#9D1DA0',
      }
      const keyOrder = ['play', 'unique_play', 'view', 'unique_view']
      return this.viewChartSeries.map((serie, idx) => {
        const key = keyOrder[idx]
        const hex = colorMap[key]
        const rgb = hex
          .replace('#', '')
          .match(/.{1,2}/g)
          .map((x) => parseInt(x, 16))
        const color =
          this.filterByMetric && this.filterByMetric !== key
            ? `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.2)`
            : hex
        return {
          ...serie,
          color,
        }
      })
    },
    lastUpdatedMinutes() {
      return Math.floor(this.lastUpdatedAt / 60) || 1
    },
    selectedVideoIds() {
      return this.selectedVideos || []
    },
    filteredVideosData() {
      if (!this.selectedVideoIds || this.selectedVideoIds.length === 0) {
        const filtered = this.videosData.filter((video) => {
          const play = Number(video.play) || 0
          const uniquePlay = Number(video.unique_play) || 0
          const view = Number(video.view) || 0
          const uniqueView = Number(video.unique_view) || 0

          return play > 0 || uniquePlay > 0 || view > 0 || uniqueView > 0
        })

        return filtered
      }
      return this.videosData
        .filter((video) =>
          this.selectedVideoIds.some(
            (videoSelected) => videoSelected.videoId === video.id
          )
        )
        .filter((video) => {
          const play = Number(video.play) || 0
          const uniquePlay = Number(video.unique_play) || 0
          const view = Number(video.view) || 0
          const uniqueView = Number(video.unique_view) || 0

          return play > 0 || uniquePlay > 0 || view > 0 || uniqueView > 0
        })
    },
    filteredTotalData() {
      const data = this.filteredVideosData
      const views = data.reduce((acc, v) => acc + (Number(v.view) || 0), 0)
      const uniqueViews = data.reduce(
        (acc, v) => acc + (Number(v.unique_view) || 0),
        0
      )
      const plays = data.reduce((acc, v) => acc + (Number(v.play) || 0), 0)
      const uniquePlays = data.reduce(
        (acc, v) => acc + (Number(v.unique_play) || 0),
        0
      )
      const playRate = uniqueViews
        ? ((uniquePlays * 100) / uniqueViews).toFixed(1)
        : 0
      return { views, uniqueViews, plays, uniquePlays, playRate }
    },
    getChartOptions() {
      const textColor = this.$vuetify.theme.currentTheme['neutral-40-light']
      const gridColor = this.$vuetify.theme.currentTheme['neutral-95-lightest']
      const isDark = this.$vuetify.theme.dark
      const localeMap = { pt: ptBR, es: esES, en: enUS }
      const localeDateFns = localeMap[this.locale] || enUS

      return {
        chart: {
          type: 'line',
          height: 300,
          width: '100%',
          toolbar: { show: false },
          zoom: { enabled: false },
        },
        stroke: { width: 2 },
        grid: {
          borderColor: gridColor,
          strokeDashArray: 0,
          yaxis: {
            lines: {
              show: true,
              color: gridColor,
            },
          },
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        xaxis: {
          tickAmount: 30,
          categories: this.chartCategories,
          tooltip: {
            enabled: false,
          },
          axisBorder: {
            show: true,
            color: gridColor,
          },
          axisTicks: {
            show: true,
            color: gridColor,
          },
          labels: {
            style: {
              fontFamily: 'Rubik, sans-serif',
              fontSize: '11px',
              fontWeight: 400,
              colors: textColor,
            },
            formatter: (value) => {
              if (!value) return value
              const showBy = this.showPlotBy
              if (showBy === 'daily') {
                return dataFormatter(value, localeDateFns)
              }
              if (showBy === 'weekly') {
                const [year, week] = value.split('-W')
                if (!year || !week) return value
                const firstDay = this.getDateOfISOWeek(
                  Number(week),
                  Number(year)
                )
                const lastDay = new Date(firstDay)
                lastDay.setDate(firstDay.getDate() + 6)
                const sameMonth = firstDay.getMonth() === lastDay.getMonth()
                const startStr = format(firstDay, sameMonth ? 'dd' : 'dd/MM', {
                  locale: localeDateFns,
                })
                const endStr = format(lastDay, 'dd/MM', {
                  locale: localeDateFns,
                })
                return `${startStr} - ${endStr}`
              }
              if (showBy === 'monthly') {
                const [year, month] = value.split('-').map(Number)
                if (!year || !month) return value
                const date = new Date(year, month - 1, 1)
                const monthStr = format(date, 'MMMM', { locale: localeDateFns })
                return monthStr.charAt(0).toUpperCase() + monthStr.slice(1)
              }
              return value
            },
            rotateAlways: this.rotateAlways,
          },
        },
        yaxis: {
          labels: {
            style: {
              fontFamily: 'Rubik, sans-serif',
              fontSize: '11px',
              fontWeight: 400,
              colors: textColor,
            },
            formatter: (value) => {
              const locale = this.locale === 'pt' ? 'pt-BR' : 'en-US'
              if (value >= 1_000_000) {
                const n = value / 1_000_000
                const isInt = Number.isInteger(n)
                return `${n.toLocaleString(locale, {
                  minimumFractionDigits: isInt ? 0 : 1,
                  maximumFractionDigits: 1,
                })}M`
              }
              if (value >= 1_000) {
                const n = value / 1_000
                const isInt = Number.isInteger(n)
                return `${n.toLocaleString(locale, {
                  minimumFractionDigits: isInt ? 0 : 1,
                  maximumFractionDigits: 1,
                })}k`
              }
              return value.toLocaleString(locale)
            },
          },
        },
        legend: { show: false },
        tooltip: {
          theme: isDark ? 'dark' : 'light',
          y: {
            title: {
              formatter: (value) => {
                return this.$t(`message.pages.analyticsV3.reference.${value}`)
              },
            },
          },
        },
      }
    },
    pdfOptions() {
      const textColor = '#636578'
      const gridColor = '#E0E0E0'
      const isDark = this.$vuetify.theme.dark
      const lang = this.locale || 'en'
      const localeMap = { pt: ptBR, es: esES, en: enUS }
      const localeDateFns = localeMap[lang] || enUS

      return {
        chart: {
          type: 'line',
          height: 300,
          width: 878,
          toolbar: { show: false },
          zoom: { enabled: false },
        },
        stroke: { width: 2 },
        grid: {
          borderColor: gridColor,
          strokeDashArray: 0,
          yaxis: {
            lines: {
              show: true,
              color: gridColor,
            },
          },
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        xaxis: {
          tickAmount: 30,
          categories: this.chartCategories,
          tooltip: {
            enabled: false,
          },
          axisBorder: { show: false },
          axisTicks: {
            show: true,
            color: gridColor,
          },
          labels: {
            style: {
              fontFamily: 'Rubik, sans-serif',
              fontSize: '11px',
              fontWeight: 400,
              colors: textColor,
            },
            formatter: (value) => {
              if (!value) return value
              const showBy = this.showPlotBy
              if (showBy === 'daily') {
                return dataFormatter(value, localeDateFns)
              }

              if (showBy === 'weekly') {
                const [year, week] = value.split('-W')
                if (!year || !week) return value // Verificação adicionada
                const firstDay = this.getDateOfISOWeek(
                  Number(week),
                  Number(year)
                )
                const lastDay = new Date(firstDay)
                lastDay.setDate(firstDay.getDate() + 6)
                const sameMonth = firstDay.getMonth() === lastDay.getMonth()
                const startStr = format(firstDay, sameMonth ? 'dd' : 'dd/MM', {
                  locale: localeDateFns,
                })
                const endStr = format(lastDay, 'dd/MM', {
                  locale: localeDateFns,
                })
                return `${startStr} - ${endStr}`
              }

              if (showBy === 'monthly') {
                const [year, month] = value.split('-').map(Number)
                if (!year || !month) return value // Verificação adicionada
                const date = new Date(year, month - 1, 1)
                const monthStr = format(date, 'MMMM', { locale: localeDateFns })
                return monthStr.charAt(0).toUpperCase() + monthStr.slice(1)
              }

              return value
            },
            rotateAlways: this.rotateAlways,
          },
        },
        yaxis: {
          labels: {
            style: {
              fontFamily: 'Rubik, sans-serif',
              fontSize: '11px',
              fontWeight: 400,
              colors: textColor,
            },
            formatter: (value) => {
              const locale = lang === 'pt' ? 'pt-BR' : 'en-US'
              if (value >= 1_000_000) {
                const n = value / 1_000_000
                const isInt = Number.isInteger(n)
                return `${n.toLocaleString(locale, {
                  minimumFractionDigits: isInt ? 0 : 1,
                  maximumFractionDigits: 1,
                })}M`
              }
              if (value >= 1_000) {
                const n = value / 1_000
                const isInt = Number.isInteger(n)
                return `${n.toLocaleString(locale, {
                  minimumFractionDigits: isInt ? 0 : 1,
                  maximumFractionDigits: 1,
                })}k`
              }
              return value.toLocaleString(locale)
            },
          },
        },
        legend: { show: false },
        tooltip: {
          theme: isDark ? 'dark' : 'light',
          y: {
            title: {
              formatter: (value) => {
                return this.$t(`message.pages.analyticsV3.reference.${value}`)
              },
            },
          },
        },
      }
    },
  },
  watch: {
    dateRange: {
      handler() {
        this.fetchAnalyticsInfo().then(() => {
          this.addPlayrate()
        })
      },
      immediate: true,
    },
    showPlotBy: {
      async handler() {
        await this.buildPlot()
      },
      immediate: true,
    },
    selectedVideoIds: {
      async handler() {
        await this.fetchAnalyticsInfo()
        await this.buildPlot()
      },
      immediate: false,
    },
  },
  async mounted() {
    this.$root.$emit('checkAdBlock')
    this.$root.$on('trigger-csv-export', this.generateAndDownloadCsv)
    this.$root.$on('trigger-png-export', this.generateAndDownloadPng)
    this.$root.$on('trigger-pdf-export', this.generatePdf)
    this.lastUpdatedTimeout = setInterval(() => {
      this.lastUpdatedAt += 1
    }, 1000)
  },
  beforeDestroy() {
    if (this.lastUpdatedTimeout) {
      clearInterval(this.lastUpdatedTimeout)
      this.lastUpdatedTimeout = null
      this.lastUpdatedAt = 0
    }
    this.$root.$off('trigger-csv-export', this.generateAndDownloadCsv)
    this.$root.$off('trigger-png-export', this.generateAndDownloadPng)
    this.$root.$off('trigger-pdf-export', this.generatePdf)
  },
  methods: {
    ...mapMutations('dashboard', ['UPDATE_IS_ADBLOCK_ENABLED']),
    ...mapMutations('analytics', ['UPDATE_ERROR_STATE']),
    handleGoToAnalyticsArticle() {
      const articleLink =
        this.analyticsLinks[this.$i18next.resolvedLanguage] ??
        this.analyticsLinks['en']
      window.open(articleLink, '_blank')
    },
    generateAndDownloadCsv() {
      const startDateFormatted = format(this.dateRange.start, 'dd_MM_yyyy')
      const endDateFormatted = format(this.dateRange.end, 'dd_MM_yyyy')
      exportToCsv(
        `analytics-plays-${startDateFormatted}--${endDateFormatted}.csv`,
        this.visibleTableColumns,
        this.tableDataForCsv
      )
    },
    async generateAndDownloadPng() {
      this.isCapturingPng = true
      await this.$nextTick()
      await new Promise(resolve => setTimeout(resolve, 1000))
      const elementToCapture = this.$refs.chartContainerForCapture
      if (elementToCapture) {
        try {
          const startDateFormatted = format(this.dateRange.start, 'dd_MM_yyyy')
          const endDateFormatted = format(this.dateRange.end, 'dd_MM_yyyy')
          const filename = `plays-${startDateFormatted}--${endDateFormatted}.png`
          
          await exportToPng(elementToCapture, filename)
        } catch (error) {
          this.UPDATE_ERROR_STATE(true)
        } finally {
          this.isCapturingPng = false
        }
      } else {
        console.error('Elemento para captura não foi encontrado.')
        this.isCapturingPng = false
      }
    },
    async generatePdf() {
      this.isCapturingPdf = true
      await this.$nextTick()
      await new Promise(resolve => setTimeout(resolve, 1000))
      const chartForPdf = this.$refs.fakeChart?.chart
      if (!chartForPdf) {
        console.error(
          'CRÍTICO: A instância do gráfico para PDF não foi encontrada. Verifique se a `viewChartSeries` tem dados.'
        )
        return
      }
      const headers = this.visibleTableColumns.map((col) => col.text)
      const dataToExport =
        this.searchVideoText.length > 0
          ? this.filteredRankingItems
          : this.filteredVideosData
      const sortedDataForPdf = [...dataToExport].sort((a, b) => {
        const playsA = Number(String(a.play).replace(/\D/g, '')) || 0
        const playsB = Number(String(b.play).replace(/\D/g, '')) || 0
        return playsB - playsA
      })
      const body = sortedDataForPdf.map((item) => {
        return this.visibleTableColumns.map((col) => {
          if (col.formatter) {
            return col.formatter(item[col.value], item).replace(/="?|"?/g, '')
          }
          if (typeof item[col.value] === 'object' && item[col.value] !== null) {
            return '-'
          }
          return item[col.value] || ''
        })
      })
      const chartHeaderData = {
        title: this.$t('message.pages.analyticsV3.plays'),
        description: this.$t('message.pages.analyticsV3.playsSubtitle'),
        metrics: this.metrics.map((metric) => ({
          label: `${metric.label}:`,
          value: Number(metric.value).toLocaleString(),
          color: metric.color,
        })),
      }
      const columnStyles = {
        0: {
          cellWidth: 'auto',
          overflow: 'ellipsize',
        },
        1: { cellWidth: 22 },
        2: { cellWidth: 22 },
        3: { cellWidth: 22 },
        4: { cellWidth: 22 },
        5: { cellWidth: 22 },
        6: { cellWidth: 22 },
      }
      const startDateFormatted = format(this.dateRange.start, 'dd_MM_yyyy')
      const endDateFormatted = format(this.dateRange.end, 'dd_MM_yyyy')
      const filename = `Plays-${startDateFormatted}--${endDateFormatted}.pdf`

      const pdfBlob = await generatePdfBlob({
        chartHeaderData: chartHeaderData,
        chartInstance: chartForPdf,
        tableHeaders: headers,
        tableBody: body,
        columnStyles: columnStyles,
      })

      this.isCapturingPdf = false
      this.$root.$emit('pdf-ready', { blob: pdfBlob, filename: filename })
    },
    clearSearch() {
      this.searchVideoText = ''
    },
    getOrderByColumn(column) {
      switch (column) {
        case 'title':
          return this.nameOrder
        case 'views':
          return this.viewsOrder
        case 'plays':
          return this.playsOrder
        case 'uniqueViews':
          return this.uniqueViewsOrder
        case 'uniquePlays':
          return this.uniquePlaysOrder
        case 'playrate':
          return this.playrateOrder
        default:
          return null
      }
    },
    handleOrderByColumn(column) {
      switch (column) {
        case 'title':
          this.handleOrderByName()
          break
        case 'views':
          this.handleOrderByViews()
          break
        case 'plays':
          this.handleOrderByPlays()
          break
        case 'uniqueViews':
          this.handleOrderByUniqueViews()
          break
        case 'uniquePlays':
          this.handleOrderByUniquePlays()
          break
        case 'playrate':
          this.handleOrderByPlayrate()
          break
      }
    },
    doItemsSearch() {
      let searchValue = this.searchVideoText
      if (searchValue && searchValue.length > 0) {
        let list = JSON.parse(JSON.stringify(this.filteredVideosData))
        let fuseOptions = {
          keys: ['title'],
          includeScore: true,
          threshold: 0.4,
        }
        const fuse = new Fuse(list, fuseOptions)
        let searchResult = fuse.search(searchValue)
        const itemsResults = searchResult.map((result) => result.item)
        this.filteredRankingItems = itemsResults
      } else {
        this.filteredRankingItems = []
      }
    },
    async fetchAnalyticsInfo() {
      this.loadings.fetch = true
      this.noInfoFound = false
      this.totalData.views = 0
      await this.fetchData()
      await this.handleUpdateAnalytics()
      this.addPlayrate()
      if (
        this.buildPlot &&
        this.buildPlot.constructor.name === 'AsyncFunction'
      ) {
        await this.buildPlot()
      } else if (this.buildPlot) {
        this.buildPlot()
      }
      this.loadings.fetch = false
    },
    getDateRange() {
      const start_date = this.dateRange?.start
        ? format(new Date(this.dateRange.start), 'yyyy-MM-dd')
        : format(subDays(new Date(), 7), 'yyyy-MM-dd')
      const end_date = this.dateRange?.end
        ? format(new Date(this.dateRange.end), 'yyyy-MM-dd')
        : format(new Date(), 'yyyy-MM-dd')
      return { start_date, end_date }
    },
    async fetchData() {
      this.clearErrors()
      this.loading = true
      this.noVideos = false
      this.allTableData = []
      try {
        const { start_date, end_date } = this.getDateRange()
        const response = await newAnalyticsApi.getAccountMetricsV2(
          start_date,
          end_date
        )
        this.UPDATE_IS_ADBLOCK_ENABLED(false)
        const data = response.data
        this.totalData.views = data.total?.view || 0
        this.totalData.uniqueViews = data.total?.unique_view || 0
        this.totalData.plays = data.total?.play || 0
        this.totalData.uniquePlays = data.total?.unique_play || 0
        let raw = data.data || data.views_data || data.daily || {}
        if (Array.isArray(raw)) {
          const obj = {}
          raw.forEach((item) => {
            if (item.date) obj[item.date] = item
          })
          raw = obj
        }
        this.rawViewsData = raw
        await this.buildPlot()
        this.errors.fetch = false
      } catch (err) {
        console.error('error: ', err)
        this.UPDATE_ERROR_STATE(true)
        this.handleFetchError(err)
      }
      this.loading = false
    },
    resetGraphData() {
      Object.keys(this.totalData).forEach((e) => (this.totalData[e] = 0))
    },
    async handleUpdateAnalytics() {
      await this.getAccountRanking()
    },
    addPlayrate() {
      this.videosData = this.videosData.map((video) => {
        const play = Number(video.play) || 0
        const uniquePlay = Number(video.unique_play) || 0
        const view = Number(video.view) || 0
        const uniqueView = Number(video.unique_view) || 0
        const cost =
          video.gb_cost && typeof video.gb_cost.video_cost_in_day === 'number'
            ? video.gb_cost.video_cost_in_day
            : 0
        const gb_cost_per_play = play > 0 ? cost / play : 0

        return {
          ...video,
          play,
          unique_play: uniquePlay,
          view,
          unique_view: uniqueView,
          playRate:
            uniqueView > 0
              ? ((uniquePlay * 100) / uniqueView).toFixed(1)
              : '0.0',
          gb_cost:
            video.gb_cost && typeof video.gb_cost === 'object'
              ? video.gb_cost
              : null,
          gb_cost_per_play,
        }
      })
    },
    async fetchVideoAnalytics(id) {
      const { start_date, end_date } = this.getDateRange()
      let ret = await newAnalyticsApi.getSingleVideoAnalytics(
        id,
        start_date,
        end_date
      )
      return ret.data
    },
    async getAccountRanking() {
      this.loadings.fetch = true
      this.wasFetch = false
      try {
        const { start_date, end_date } = this.getDateRange()
        let ret = await newAnalyticsApi.getRanking(start_date, end_date)
        if (!ret.data.length) this.noInfoFound = true
        this.videosData = ret.data
        this.viewsOrder = 'desc'
        this.addPlayrate()
        this.errors.fetch = false
      } catch (e) {
        console.error('error: ', e)
        this.UPDATE_ERROR_STATE(true)
        this.loadings.fetch = false
      }
      this.wasFetch = true
      this.loadings.fetch = false
    },
    aggregateDataByDate(views_data, startDate, endDate) {
      const dailyMap = {}
      const weeklyMap = {}
      const monthlyMap = {}
      let data = views_data
      if (Array.isArray(views_data)) {
        data = {}
        for (const item of views_data) {
          if (item.date) data[item.date] = item
        }
      }
      for (const dateStr in data) {
        const stats = data[dateStr]
        const date = new Date(dateStr)
        const dailyKey = dateStr
        const weekNumber = this.getWeekNumber(date)
        const weeklyKey = `${date.getFullYear()}-W${weekNumber
          .toString()
          .padStart(2, '0')}`
        const monthlyKey = `${date.getFullYear()}-${(date.getMonth() + 1)
          .toString()
          .padStart(2, '0')}`
        if (!dailyMap[dailyKey])
          dailyMap[dailyKey] = {
            date: dailyKey,
            view: 0,
            play: 0,
            unique_view: 0,
            unique_play: 0,
          }
        dailyMap[dailyKey].view += stats.view || 0
        dailyMap[dailyKey].play += stats.play || 0
        dailyMap[dailyKey].unique_view += stats.unique_view || 0
        dailyMap[dailyKey].unique_play += stats.unique_play || 0
        if (!weeklyMap[weeklyKey])
          weeklyMap[weeklyKey] = {
            date: weeklyKey,
            view: 0,
            play: 0,
            unique_view: 0,
            unique_play: 0,
          }
        weeklyMap[weeklyKey].view += stats.view || 0
        weeklyMap[weeklyKey].play += stats.play || 0
        weeklyMap[weeklyKey].unique_view += stats.unique_view || 0
        weeklyMap[weeklyKey].unique_play += stats.unique_play || 0
        if (!monthlyMap[monthlyKey])
          monthlyMap[monthlyKey] = {
            date: monthlyKey,
            view: 0,
            play: 0,
            unique_view: 0,
            unique_play: 0,
          }
        monthlyMap[monthlyKey].view += stats.view || 0
        monthlyMap[monthlyKey].play += stats.play || 0
        monthlyMap[monthlyKey].unique_view += stats.unique_view || 0
        monthlyMap[monthlyKey].unique_play += stats.unique_play || 0
      }
      let dailyArr = []
      if (startDate && endDate) {
        const range = this.getContinuousDateRange(startDate, endDate)
        dailyArr = range.map(
          (date) =>
            dailyMap[date] || {
              date,
              view: 0,
              play: 0,
              unique_view: 0,
              unique_play: 0,
            }
        )
      } else {
        dailyArr = Object.values(dailyMap).sort(
          (a, b) => new Date(a.date) - new Date(b.date)
        )
      }
      return {
        daily: dailyArr,
        weekly: Object.values(weeklyMap).sort((a, b) =>
          a.date.localeCompare(b.date)
        ),
        monthly: Object.values(monthlyMap).sort((a, b) =>
          a.date.localeCompare(b.date)
        ),
      }
    },
    getWeekNumber(date) {
      const d = new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
      )
      const dayNum = d.getUTCDay() || 7
      d.setUTCDate(d.getUTCDate() + 4 - dayNum)
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
      return Math.ceil(((d - yearStart) / 86400000 + 1) / 7)
    },
    buildSeriesFromAggregatedData(data) {
      const props = ['play', 'unique_play', 'view', 'unique_view']
      const colors = ['#3F55EE', '#20C1A4', '#FF882B', '#9D1DA0']
      return props.map((prop, idx) => {
        return {
          name: prop,
          data: data.map((entry) => entry[prop] || 0),
          color: colors[idx],
        }
      })
    },
    getCategoriesFromData(data) {
      return data.map((entry) => entry.date)
    },
    getDateOfISOWeek(week, year) {
      const simple = new Date(year, 0, 1 + (week - 1) * 7)
      const dow = simple.getDay()
      const ISOweekStart = simple
      if (dow <= 4) {
        ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1)
      } else {
        ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay())
      }
      return ISOweekStart
    },
    getContinuousDateRange(start, end) {
      console.log('start', start)
      console.log('end', end)
      const dates = []
      let d = new Date(start + 'T12:00:00')
      const endDate = new Date(end + 'T12:00:00')
      while (d <= endDate) {
        dates.push(format(d, 'yyyy-MM-dd'))
        d.setDate(d.getDate() + 1)
      }
      return dates
    },
    getContinuousWeekRange(start, end) {
      const weeks = []
      let d = new Date(start + 'T12:00:00')
      const endDate = new Date(end + 'T12:00:00')
      while (d <= endDate) {
        const weekNumber = this.getWeekNumber(d)
        const weekKey = `${d.getFullYear()}-W${weekNumber
          .toString()
          .padStart(2, '0')}`
        if (!weeks.includes(weekKey)) weeks.push(weekKey)
        d.setDate(d.getDate() + 7)
      }
      return weeks
    },
    getContinuousMonthRange(start, end) {
      const months = []
      let d = new Date(start + 'T12:00:00')
      const endDate = new Date(end + 'T12:00:00')
      while (d <= endDate) {
        const monthKey = `${d.getFullYear()}-${(d.getMonth() + 1)
          .toString()
          .padStart(2, '0')}`
        if (!months.includes(monthKey)) months.push(monthKey)
        d.setMonth(d.getMonth() + 1)
      }
      return months
    },
    async buildPlot() {
      if (this.selectedVideoIds && this.selectedVideoIds.length > 0) {
        const { start_date, end_date } = this.getDateRange()
        const videoIds = this.selectedVideoIds.map(
          (v) => v.videoId || v.id || v
        )
        let allData = {}
        this.totalData.views = 0
        this.totalData.uniqueViews = 0
        this.totalData.plays = 0
        this.totalData.uniquePlays = 0
        const missingVideoIds = videoIds.filter(
          (id) => !this.rawVideoDataById[id]
        )
        if (missingVideoIds.length > 0) {
          try {
            const responses = await Promise.all(
              missingVideoIds.map((id) =>
                newAnalyticsApi.getSingleVideoAnalytics(
                  id,
                  start_date,
                  end_date
                )
              )
            )

            responses.forEach((resp, index) => {
              const videoId = missingVideoIds[index]
              this.rawVideoDataById[videoId] =
                resp.data.data || resp.data.views_data || resp.data.daily || {}
            })
          } catch (e) {
            this.viewChartSeries = []
            this.chartCategories = []
            return
          }
        }

        videoIds.forEach((videoId) => {
          const videoData = this.rawVideoDataById[videoId] || {}
          console.log('videoData', videoData)
          Object.entries(videoData).forEach(([date, stats]) => {
            let normDate = date
            if (date.length > 10) {
              normDate = date.slice(0, 10)
            }
            if (!allData[normDate]) {
              allData[normDate] = {
                date: normDate,
                play: 0,
                unique_play: 0,
                view: 0,
                unique_view: 0,
              }
            }
            allData[normDate].play += stats.play || 0
            allData[normDate].unique_play += stats.unique_play || 0
            allData[normDate].view += stats.view || 0
            allData[normDate].unique_view += stats.unique_view || 0
          })
        })

        if (!Object.keys(allData).length) {
          this.viewChartSeries = []
          this.chartCategories = []
          return
        }

        const totals = {
          play: 0,
          unique_play: 0,
          view: 0,
          unique_view: 0,
        }

        for (const key in allData) {
          const entry = allData[key]
          totals.play += entry.play
          totals.unique_play += entry.unique_play
          totals.view += entry.view
          totals.unique_view += entry.unique_view
        }

        this.totalData.views = totals.view
        this.totalData.uniqueViews = totals.unique_view
        this.totalData.plays = totals.play
        this.totalData.uniquePlays = totals.unique_play

        const aggregated = this.aggregateDataByDate(
          allData,
          start_date,
          end_date
        )
        let arr = []
        if (this.showPlotBy === 'daily') {
          arr = aggregated.daily
        } else if (this.showPlotBy === 'weekly') {
          const range = this.getContinuousWeekRange(start_date, end_date)
          const map = {}
          aggregated.weekly.forEach((item) => {
            map[item.date] = item
          })
          arr = range.map(
            (date) =>
              map[date] || {
                date,
                play: 0,
                unique_play: 0,
                view: 0,
                unique_view: 0,
              }
          )
        } else if (this.showPlotBy === 'monthly') {
          const range = this.getContinuousMonthRange(start_date, end_date)
          const map = {}
          aggregated.monthly.forEach((item) => {
            map[item.date] = item
          })
          arr = range.map(
            (date) =>
              map[date] || {
                date,
                play: 0,
                unique_play: 0,
                view: 0,
                unique_view: 0,
              }
          )
        }
        const series = this.buildSeriesFromAggregatedData(arr)
        this.viewChartSeries = [...series]
        this.chartCategories = [...arr.map((item) => item.date)]
        return
      }
      let dataToAggregate = this.rawViewsData
      if (!dataToAggregate || Object.keys(dataToAggregate).length === 0) {
        this.viewChartSeries = []
        this.chartCategories = []
        this.totalData.views = 0
        this.totalData.uniqueViews = 0
        this.totalData.plays = 0
        this.totalData.uniquePlays = 0
        return
      }
      const { start_date, end_date } = this.getDateRange()
      const aggregated = this.aggregateDataByDate(
        dataToAggregate,
        start_date,
        end_date
      )
      const arr = aggregated[this.showPlotBy] || []
      const series = this.buildSeriesFromAggregatedData(arr)
      this.viewChartSeries = series
      this.chartCategories = this.getCategoriesFromData(arr)
    },
    getVideoValuePromises(keys) {
      const start_date = this.dateRange?.start
        ? format(new Date(this.dateRange.start), 'yyyy-MM-dd')
        : format(subDays(new Date(), 7), 'yyyy-MM-dd')
      const end_date = this.dateRange?.end
        ? format(new Date(this.dateRange.end), 'yyyy-MM-dd')
        : format(new Date(), 'yyyy-MM-dd')
      keys = keys.map((id) => {
        if (id?.id) id = id.id
        return newAnalyticsApi.getSingleVideoAnalytics(id, start_date, end_date)
      })
      return keys
    },
    async fetchGeneralChartGraphic() {
      try {
        const today = new Date()
        const oneWeekAgo = subDays(today, 7)
        const start_date = format(oneWeekAgo, 'yyyy-MM-dd')
        const end_date = format(today, 'yyyy-MM-dd')

        const response = await newAnalyticsApi.getGeneralExternalPlays(
          start_date,
          end_date
        )
        const valueDataArray = response.data.valueData.map(({ p }) => p)
        const categories = response.data.map((item) => {
          const date = this.getUTCDate(item.t)
          return date.getTime()
        })

        this.options.series[0].data = valueDataArray
        this.options.labels = categories
      } catch (err) {
        console.error('error: ', err)
        this.UPDATE_ERROR_STATE(true)
        this.handleFetchError(err)
      }
    },
    clearErrors() {
      this.errors.fetch = false
      this.errors.unknownError = false
      this.errors.shownErrMsg = ''
      this.errors.tooltipErrMsg = ''
    },
    formatNumberTotalTraffic(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    handleScroll(event) {
      const scrollTop = event.target.scrollTop
      this.isScrolled = scrollTop > 5
    },
    formatAverageCost(cost, play) {
      if (!play || !cost || typeof cost !== 'number' || isNaN(cost)) return '0'
      const value = cost / play
      if (typeof value !== 'number' || isNaN(value) || !isFinite(value))
        return '-'
      if (value >= 1) {
        return Math.round(value).toLocaleString(this.currencyLocale, {
          style: 'currency',
          currency: this.currency,
        })
      }
      return value.toLocaleString(this.currencyLocale, {
        style: 'currency',
        currency: this.currency,
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      })
    },
    insertBreakAfterFirstWord(text) {
      if (!text) return ''
      const [first, ...rest] = text.split(' ')
      return `${first}<br />${rest.join(' ')}`
    },
    handleFilterByMetric(metric) {
      if (this.filterByMetric === metric) {
        this.filterByMetric = null
      } else {
        this.filterByMetric = metric
      }
    },
    truncateTitle(title, maxLength = 38) {
      if (!title) return '-'
      return title.length > maxLength
        ? title.slice(0, maxLength - 3) + '...'
        : title
    },
  },
}
</script>
<style lang="scss">
.apexcharts-legend {
  display: none !important;
}
.upCardAnalyticsGraphic {
  .v-skeleton-loader__image {
    height: 288px;
  }
}
</style>
<style lang="scss" scoped>
.upCardAnalyticsGraphic,
.upCardAnalyticsTable {
  border-radius: 8px;
  background-color: varFigma(neutral-100-white);

  .title {
    color: varFigma(neutral-20-dark);
  }
  .subtitle {
    color: varFigma(neutral-30-base);
  }
}
.columnDisplay {
  border-radius: 8px !important;
}

.upCardAnalyticsTable {
  margin-top: 24px;
}
.tableOrganicContent {
  padding: 0 1rem;

  .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    color: varFigma(neutral-20-dark) !important;
  }
}

.paginationTable {
  .v-pagination__navigation {
    box-shadow: none;
  }
  .v-pagination__navigation {
    border: 1px solid varFigma(neutral-95-lightest);
    border-radius: 12px;

    &:hover {
      border: 1px solid varFigma(brand-80-light);
    }
  }
  .v-pagination__item {
    border-radius: 12px;
    box-shadow: none;
    border: 1px solid varFigma(neutral-95-lightest);
    &:hover {
      border: 1px solid varFigma(brand-80-light);
    }
  }
  .v-pagination__item.primary {
    box-shadow: none;
    border: 1px solid varFigma(brand-60-base);
    background: varFigma(brand-95-lighter) !important;
    color: varFigma(brand-40-dark) !important;
    &:hover {
      border: 1px solid varFigma(brand-80-light) !important;
      background: varFigma(brand-80-light) !important;
      color: varFigma(brand-30-darker) !important;
    }
  }
}

.v-data-table {
  .v-data-table__wrapper > table > thead > tr > th {
    background: varFigma(neutral-100-white);
    color: varFigma(neutral-20-dark);
    font-family: Rubik;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
    padding: 16px 0;
    border-bottom: 1px solid varFigma(neutral-95-lightest);
    text-align: inherit;
    min-width: 125px;
  }

  .v-data-table__wrapper
    > table
    > tbody
    > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background-color: varFigma(neutral-100-white) !important;
  }
  .v-data-table__wrapper
    > table
    > tbody
    > tr:not(:last-child)
    > td:not(.v-data-table__mobile-row) {
    border-bottom: thin solid varFigma(neutral-95-lightest) !important;
    min-width: 125px;
  }
  .v-data-footer__pagination {
    margin-left: auto;
    padding: 1rem 0;
  }
  .v-data-footer__select {
    display: none;
  }
  .v-data-footer {
    display: none;
  }
}

.table-header {
  position: sticky;
  top: 120px;
  z-index: 1;
  background: varFigma(neutral-100-white);
  padding: 16px 0;
  border-bottom: 1px solid varFigma(neutral-95-lightest);
  transition: all 0.3s ease;

  &.scrolled {
    box-shadow: 0 8px 16px -4px rgba(0, 0, 0, 0.15);
  }
}

.tableHeaderTitles {
  width: 100%;
  background: varFigma(neutral-100-white);

  &--item {
    color: varFigma(neutral-40-light);
    text-align: inherit;
    min-width: 125px;
  }
}

.tableViews {
  width: 97%;
  margin-top: 8px;
  flex: 1;
  display: flex;
  flex-direction: column;

  .v-data-table__wrapper {
    flex: 1;
    overflow-y: visible;

    #SvgjsPath1370 {
      stroke: red;
    }
  }
}

.content-footer {
  width: 100%;
  margin-top: auto;
  padding: 16px 0;
  background: varFigma(neutral-100-white);
}

.recordsNumber {
  color: varFigma(neutral-40-light);
}

.emptyStateTrafficModal {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;

  .emptyState {
    &--title {
      color: varFigma(neutral-20-dark);
    }
    &--subtitle {
      color: varFigma(neutral-40-light);
    }
  }

  @media (max-height: 1024px) {
    padding: 32dvh 0;
  }
  @media (max-height: 768px) {
    padding: 30dvh 0;
  }
  .body-label-xs {
    color: varFigma(neutral-20-dark);
    font-family: Rubik;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}

.scrollable-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
}

.metric-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 4px;
  :hover {
    background-color: varFigma(neutral-95-lightest);
    border-radius: 8px;
    cursor: pointer;
  }
}
.metric-btn--opacity {
  opacity: 0.2;
}
.my-badge-scope .v-badge__badge {
  height: 12px !important;
  width: 12px !important;
  min-width: 12px !important;
  max-height: 12px !important;
  padding: 0 !important;
  line-height: 12px !important;
  font-size: 0 !important;
}

.apexcharts-tooltip {
  background-color: varFigma(neutral-100-white) !important;
  color: varFigma(neutral-20-dark) !important;
  border: 1px solid varFigma(neutral-95-lightest) !important;
}

.apexcharts-tooltip-title {
  background-color: varFigma(neutral-95-lightest) !important;
  color: varFigma(neutral-20-dark) !important;
  font-weight: 500;
  padding: 6px 10px;
}

.pdf-export-chart {
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: -1;
}

.span-link:hover {
  text-decoration: underline !important;
}

.capture-clone {
  position: absolute;
  top: -9999px;
  left: -9999px;
  pointer-events: none;
  height: 450px;
  width: 1200px; 
  background: white;
  box-sizing: border-box;
  font-family: Rubik;
}


</style>
